import { MetadataWithId } from './model/metadata-with-id';

export class PersistAndCleanupStartupTempData {
  static readonly type = '[StartupTempData] Persist and cleanup startup temp data';
  constructor(public metadataId: string | null) {}
}

export class SetStartupTempData {
  static readonly type = '[StartupTempData] Set startup temp data';
  constructor(public metadataWithId: MetadataWithId | null, public forceSignIn: boolean) {}
}
